import type { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useUpdatePassword = () =>
  useMutation({
    mutationFn: updatePassword,
  });

const updatePassword = async ({ newPassword, token }: UpdateEmailParams) => {
  await api.put<void, AxiosResponse<void>, UpdatePasswordBody>(
    apiConfig.routes.auth.updatePassword,
    { new_password: newPassword, token }
  );
};

type UpdateEmailParams = {
  newPassword: string;
  token: string;
};

type UpdatePasswordBody = {
  new_password: string;
  token: string;
};
